import gql from 'graphql-tag'

const query = gql`
	query listCurrencyUnits($language: Language!) {
		cashAssist {
			listCurrencyUnits(language: $language) {
            name
            code
        }
    }
	}`

export default query
